import styled from 'styled-components';

export const StyledAssignModal = styled.div`
  padding: 24px 28px;

  > div {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    padding: 6px 0;

    > div {
      .cbx {
        margin: 0;
      }
    }

    .label-span {
      color: var(--color-text-main) !important;
    }
  }
`;

export const StyledAddTitle = styled.h3`
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 20px;
`;
